import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {FilterType} from './filter-type';
import {PageEvent} from "@angular/material/paginator";
import {EmptyPager} from "../../modules/routing/index-entity/index-entity.component";


@Injectable({
    providedIn: 'root'
})
export class PagerStoreService implements StoreService {
    private readonly PAGER_STORAGE_POSTFIX = '-pager'

    constructor(private storage: StorageService) {
    }

    set(type: string, value: PageEvent): void {
        this.storage.setItem(type+this.PAGER_STORAGE_POSTFIX, JSON.stringify(value));
    }

    get(type: string): PageEvent {
        const res = this.storage.getItem(type+this.PAGER_STORAGE_POSTFIX);
        if (!res) return EmptyPager;
        const result = {...EmptyPager,...JSON.parse(res)};
        return result
    }

    remove(type: FilterType): void {
        this.storage.removeItem(type+this.PAGER_STORAGE_POSTFIX);
    }

}
